<template>
  <div class="buy-page">
    <nav>
      <TopNav />
    </nav>
    <div style="height: 190px"/>
    <div class="shop-list">
      <div class="shop-item" v-for="(item, itemInd) in shopList" :key="itemInd">
        <img :src="item.img"/>
        <div>{{item.name}}</div>
        <div class="about-more" @click="goToShop(item.link)">立即进店></div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import TopNav from "./components/TopNav.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "Buy",
  components: {Footer, TopNav},
  data(){
    return {
      shopList: [
        {name: '天猫旗舰店',link: 'https://detail.tmall.com/item.htm?id=759819355376',img: require('../../assets/image/tm.png')},
        {name: '京东旗舰店',link: 'https://item.jd.com/10099773768137.html',img: require('../../assets/image/jd.png')},
        {name: '抖音旗舰店',link: 'https://haohuo.jinritemai.com/ecommerce/trade/detail/index.html?id=3688275873254998316&origin_type=604',img: require('../../assets/image/dy.png')},
        {name: '小红书旗舰店',link: 'https://www.xiaohongshu.com/goods-detail/66052a9a5c3c5a000145c6a5?xhsshare=CopyLink&appuid=5c37034e000000000700a4c9&apptime=1716456882',img: require('../../assets/image/hs.png')},
      ]
    }
  },
  methods: {
    goToShop(link) {
      window.open(link)
    }
  }
}
</script>
<style lang="less"  scoped>
.buy-page {
  height: 100%;
  font-size: 16px;
  .shop-list {
    display: flex;
    flex-direction: row;
    width: 490px;
    margin: 0 auto;
    flex-wrap: wrap;
    justify-content: space-between;
    .shop-item {
      width: 230px;
      background: #f5f5f5;
      height: 200px;
      align-items: center;
      border-radius: 10px;
      -webkit-border-radius: 10px;
      display: flex;
      flex-direction: column;
      margin-bottom: 40px;
      img {
        width: 80px;
        height: 80px;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        margin: 25px auto 10px;
      }
      .about-more {
        color: #ffffff;
        border-radius: 5px;
        font-size: 14px;
        padding: 5px 0;
        width: 120px;
        text-align: center;
        background: linear-gradient(to right,#DDC4A9,#D2B08C);
        flex: 0 0 auto;
        cursor: pointer;
        margin-top: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/new/Buy.vue